import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

interface balance_type {
  id: string // 钱包id
  currency: string //	货币类型
  status_name: string //	状态名称
  available_balance: string //	 可用余额
}
interface InitialStateType {
  payoneer_get_balance?: {
    items: balance_type[]
    amount: string
    order_id: string
  }
  payoneer_choose_currency?: {
    err_msg: string //	错误信息
    order_amount: string //	订单金额
    fx_rate: string //	汇率换算
    payment_amount: string //		账单金额
    commit_id: string //		传给下个接口
  }
}
const initialState: InitialStateType = {}

// [payoneer 获取用户余额](http://wiki.xunlei.cn/pages/viewpage.action?pageId=117031078)
export const payoneer_get_balancet = createAsyncThunk(
  '/live/pay/payoneer_get_balancet',
  async (
    data: {
      code: string
      state: string
    },
    store
  ) => {
    const resp = await http.post('/live/pay/payoneer_get_balance', data)
    return resp.data.data
  }
)

// [payoneer 选择使用哪个钱包的接口](http://wiki.xunlei.cn/pages/viewpage.action?pageId=117031081)
export const payoneer_choose_currency = createAsyncThunk(
  '/live/pay/payoneer_choose_currency',
  async (
    data: {
      balance_id: string
      order_id: string
    },
    store
  ) => {
    const resp = await http.post('/live/pay/payoneer_choose_currency', data, {
      xcErrorToast: true,
    })
    return resp.data.data
  }
)

// [payoneer 确认支付](http://wiki.xunlei.cn/pages/viewpage.action?pageId=117031091)
export const payoneer_commit = createAsyncThunk(
  '/live/pay/payoneer_commit',
  async (
    data: {
      commit_id: string
      order_id: string
    },
    store
  ) => {
    const resp = await http.post<
      HiyaRes<{
        redirect_url: string
      }>
    >('/live/pay/payoneer_commit', data, {
      xcErrorToast: true,
    })
    return resp.data.data
  }
)

// [payoneer 切换绑定账号](http://wiki.xunlei.cn/pages/viewpage.action?pageId=117033224)
export const payoneer_change_account = createAsyncThunk(
  '/live/pay/payoneer_change_account',
  async (
    data: {
      state: string
    },
    store
  ) => {
    const resp = await http.post<
      HiyaRes<{
        redirect_url: string
      }>
    >('/live/pay/payoneer_change_account', data, {
      xcErrorToast: true,
    })
    return resp.data.data
  }
)
// [payoneer 查询，最终短信验证码之后最终使用哪个轮询页面](http://wiki.xunlei.cn/pages/viewpage.action?pageId=117033065)
export const payoneer_commit_after = createAsyncThunk(
  '/live/pay/payoneer_commit_after',
  async (
    data: {
      session_id: string
      response_path: string
    },
    store
  ) => {
    const resp = await http.post<
      HiyaRes<{
        redirect_url: string
      }>
    >('/live/pay/payoneer_commit_after', data)
    return resp.data.data
  }
)

export const Wallet2PayoneerSlice = createSlice({
  name: 'Wallet2Payoneer',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(payoneer_get_balancet.fulfilled, (state, action) => {
      Object.assign(state, {
        payoneer_get_balance: action.payload,
      })
    })

    builder.addCase(payoneer_choose_currency.fulfilled, (state, action) => {
      Object.assign(state, {
        payoneer_choose_currency: action.payload,
      })
    })
  },
})
export const Wallet2PayoneerSliceActions = Wallet2PayoneerSlice.actions
export default Wallet2PayoneerSlice.reducer
